import React from 'react';
import { Link } from 'react-router-dom';

const ActivosIndex = () => (
  <div className="p-8 max-w-4xl">
    <h1 className="text-2xl font-semibold text-gray-900 mb-2">Activos</h1>
    <p className="text-gray-600 mb-8">
      Registro de activos con clasificación propia (categoría, subcategoría y familia) y ubicación por área de empresa.
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <Link
        to="/activos/listado"
        className="block p-5 border border-gray-200 rounded-xl hover:border-teal-500 hover:bg-teal-50/40 transition-colors"
      >
        <span className="text-2xl" aria-hidden>
          📦
        </span>
        <h2 className="mt-2 font-medium text-gray-900">Listado de activos</h2>
        <p className="text-sm text-gray-500 mt-1">Consulte y registre activos indicando en qué área se encuentran.</p>
      </Link>
      <Link
        to="/activos/en-uso"
        className="block p-5 border border-gray-200 rounded-xl hover:border-teal-500 hover:bg-teal-50/40 transition-colors"
      >
        <span className="text-2xl" aria-hidden>
          🏢
        </span>
        <h2 className="mt-2 font-medium text-gray-900">En uso por áreas</h2>
        <p className="text-sm text-gray-500 mt-1">Activos que ya iniciaron actividades, agrupados por área. Corrija fechas si hubo error.</p>
      </Link>
      <Link
        to="/activos/financiero/depreciacion"
        className="block p-5 border border-gray-200 rounded-xl hover:border-teal-500 hover:bg-teal-50/40 transition-colors"
      >
        <span className="text-2xl" aria-hidden>
          💰
        </span>
        <h2 className="mt-2 font-medium text-gray-900">Depreciación</h2>
        <p className="text-sm text-gray-500 mt-1">Prorrateo del costo sin IGV por vida útil, reportes por activo, área y período.</p>
      </Link>
      <Link
        to="/activos/configuracion/clasificacion/categorias"
        className="block p-5 border border-gray-200 rounded-xl hover:border-teal-500 hover:bg-teal-50/40 transition-colors"
      >
        <span className="text-2xl" aria-hidden>
          ⚙️
        </span>
        <h2 className="mt-2 font-medium text-gray-900">Configuración</h2>
        <p className="text-sm text-gray-500 mt-1">Clasificación de activos y áreas de empresa para ubicación.</p>
      </Link>
    </div>
  </div>
);

export default ActivosIndex;
